const COLOR_GREEN = "green";
const COLOR_BLUE = "blue";
const COLOR_RED = "red";



const HardCodedMicroscopyTemplateMap = {

  regionInBottomLeft:{
    images:{
      im0:{ color:"blue", label:"DAPI" },
      im1:{ color:"red", label:"RFP" },
    },
    channelGroupStructure:[["A","B","C","D"]],
    channels:{
      A:{ colors:[COLOR_GREEN], images:["im0"], },
      B:{ colors:[COLOR_BLUE], images:["im1"] },
      C:{ colors:[COLOR_RED], images:["im0","im1"] },
      D:{ colors:[COLOR_RED,COLOR_BLUE,COLOR_GREEN] }
    },
    defaultStyleByType:{
      region:{ }
    },
    regions:[{
      all:{ 
        location:"inside",
        position:{ base:"bl" },
      }
    }],

  },
  

  singleton:{
    channelGroupStructure:[["A"]],
    channels:{
      A:{ colors:[COLOR_RED] }
    },
    defaultStyleByType:{
      region:{
        padding:1
      }
    },
    regions:[],
  },

  block:{
    channelGroupStructure:[["A","B"],["C","D"]],
    channels:{
      A:{ colors:[COLOR_GREEN] },
      B:{ colors:[COLOR_BLUE] },
      C:{ colors:[COLOR_RED] },
      D:{ colors:[COLOR_RED,COLOR_BLUE,COLOR_GREEN] }
    },
    defaultStyleByType:{
      region:{
        padding:1
      }
    },
    regions:[],

  },
  channelBased:{
    channelGroupStructure:["A B C D"],
    channels:{
      A:{ colors:[COLOR_GREEN] },
      B:{ colors:[COLOR_BLUE] },
      C:{ colors:[COLOR_RED] },
      D:{ colors:[COLOR_RED,COLOR_BLUE,COLOR_GREEN] }
    },
    defaultStyleByType:{
      region:{
        padding:1
      }
    },
    regions:[],

  },
  
  bb0:{ 

    defaultStyleByType:{
      region:{
        padding:1,
      }
    },
    channelGroupStructure:"012 0 1 2", 
    regions:[{"all":{location:"above"},
      "01,02,12,21,012,0,1,2":{location:"above"} 
    } ],
    //scalebar:[ {"all":{ location:{ base:"tr" } }}, {"012":{ location:{ base:"br" } }} ]
  },

  basic:{ 
    channelGroupStructure:[["012","0","1","2"]], 
    channelGroups:{
      "012":["0c","1c","2c"],
      "0":["0c"],
      "1":["1c"],
      "2":["2c"],
    },
    channels:{
      "0c":{ color:COLOR_RED },
      "1c":{ color:COLOR_GREEN },
      "2c":{ color:COLOR_BLUE },
    },
    defaultStyleByType:{
      region:{
        padding:1
      }
    },
    regions:[
      {
        "012,2":{ // applies to 012,2 channels
          location:"inside",
          position:{ base:"bl" },
          style:{
            padding:1,
            maxWidth:'50%',
            maxHeight:'50%',
            borderWidth:1,
            borderStyle:'solid',
            borderColor:'white',

          }
        }
      }
    ],
    /*
      scaleBar:[
        {
          all:{
            position:{ base:"br" },
            style:{ color:"white", },
            length:100,
            units:"μm",
            text:false
          },
          "012":{
            text:true
          }
        }
      ],
      */

    text:[
      { 
        all:{ 
          position:{ base:"tl", }, 
          label:"Label", 
          style:{ color:'white', fontWeight:"bold", background:"black" } 
        }, 
        
        "012":{ "style.color":"white" },
        "0":{ "style.color":COLOR_RED },
        "1":{ "style.color":"lime" },
        "2":{ "style.color":"skyblue" } 
      }
    ] 
  },

  basicComplete:{ 
    channelGroupStructure:[["012","0","1","2"]],

    defaultStyleByType:{
      region:{
        padding:1
      },
    },
    regions:[
      {
        "012,0,1,2":{ // applies to 012,2 channels
          location:"inside",
          position:{ base:"bl" },
          style:{
            maxWidth:'50%',
            borderWidth:1,
            borderStyle:'solid',
            borderColor:'white',

          }
        }
      }
    ],
    /*
      scaleBar:[
        {
          all:{
            position:{ base:"br" },
            style:{ color:"white", },
            length:100,
            units:"μm",
            text:false
          },
          "012":{
            text:true
          }
        }
      ],
      */

    text:[
      { 
        all:{ 
          position:{ base:"tl", }, 
          label:"Label", 
          style:{ fontWeight:"bold", background:"black",
            color:'white',
          } 
        }, 
        "012":{ "style.color":"white" },
        "0":{ "style.color":COLOR_RED },
        "1":{ "style.color":"lime" },
        "2":{ "style.color":"skyblue" } 
      }
    ] 
  },

  basicCompleteFlipped:{ 
    channelGroupStructure:"0 1 2 012", 

    defaultStyleByType:{
      region:{
        padding:1
      }
    },
    regions:[
      {
        "012,0,1,2":{ // applies to 012,2 channels
          location:"inside",
          position:{ base:"bl" },
          style:{
            maxWidth:'50%',
            borderWidth:1,
            borderStyle:'solid',
            borderColor:'white',

          }
        }
      }
    ],
    /*
      scaleBar:[
        {
          all:{
            position:{ base:"br" },
            style:{ color:"white", },
            length:100,
            units:"μm",
            text:false
          },
          "012":{
            text:true
          }
        }
      ],
      */

    text:[
      { 
        all:{ 
          position:{ base:"tl", }, 
          label:"Label", 
          style:{ fontWeight:"bold", background:"black" } 
        }, 
        "012":{ "style.color":"white" },
        "0":{ "style.color":COLOR_RED },
        "1":{ "style.color":"lime" },
        "2":{ "style.color":"skyblue" } 
      }
    ] 
  },


  below:{ 

    images:{
      A:{ color:"red", label:"mCherry" }
    },
    channelGroupStructure:"012 0 1 2", 

    defaultStyleByType:{
      region:{
        padding:1
      }
    },

    /*
      regionStructure:"I_bl", 
      regionChannels:"012 2", 
      */

    regions:[
      {
        "012,0,1,2":{
          location:"below",
          style:{ padding:1 }
          //position:{ base:"bl" },
          /*style:{
              maxWidth:'50%',
            }*/
          }
      }
    ],

    text:[
      { 
        all:{ 
          position:{ alignItems:'start', justifyContent:'start' }, 
          label:"Label", 
          style:{ fontWeight:"bold", background:"black" } 
        }, 
        "012":{ "style.color":"white" },
        "0":{ "style.color":COLOR_RED },
        "1":{ "style.color":"lime" },
        "2":{ "style.color":"skyblue" } 
      }
    ] 
  },

  above:{ 
    channelGroupStructure:"012 0 1 2", 

    images:{
      A:{ color:"red", label:"mCherry" }
    },

    defaultStyleByType:{
      region:{
        padding:1
      }
    },

    /*
      regionStructure:"I_bl", 
      regionChannels:"012 2", 
      */

    regions:[

      {
        "01,02,12,012,0,1,2":{
          location:"above",
          style:{ padding:1 }
          //position:{ base:"bl" },
          /*style:{
              maxWidth:'50%',
            }*/
          }
      },
    ],

    text:[
      { 
        all:{ 
          position:{ alignItems:'start', justifyContent:'start' }, 
          label:"Label", 
          style:{ fontWeight:"bold", background:"black" } 
        }, 
        "012":{ "style.color":"white" },
        "0":{ "style.color":COLOR_RED },
        "1":{ "style.color":"lime" },
        "2":{ "style.color":"skyblue" } 
      }
    ] 
  }
}

export default HardCodedMicroscopyTemplateMap;
